<template>
  <div>
    <div v-if="ticketHistory" class="my-3 text-center">
      <table>
        <tr>
          <th>{{ $t('ticket_hash') }}</th>
          <th>{{ $t('status') }}</th>
          <th>{{ $t('type') }}</th>
          <th>{{ $t('site') }}</th>
          <th>{{ $t('created_by') }}</th>
          <th>{{ $t('date_created') }}</th>
          <th>{{ $t('date_closed') }}</th>
          <th>{{ $t('view_ticket') }}</th>
        </tr>
        <tr v-for="(ticket, index) in ticketHistory" :key="ticket.CaseNumber" :class="index % 2 === 0 ? '' : 'odd'">
          <th>{{ ticket.CaseNumber }}</th>
          <td>{{ ticket.Status }}</td>
          <td>{{ ticket.Record_Type_Name__c	 }}</td>
          <td>{{ !ticket.SiteName__r ? null : ticket.SiteName__r.Name }}</td>
          <td>{{ !ticket.Contact ? null : ticket.Contact.Name }}</td>
          <td>{{ Vue.unifyDateFormat(ticket.CreatedDate) }}</td>
          <td>{{ Vue.unifyDateFormat(ticket.ClosedDate) }}</td>
          <td>
            <button class="btn btn-default btn-xs" @click="getTicket(ticket.Id)">{{ $t('view_ticket') }}</button>
          </td>
        </tr>
      </table>
    </div>
    <no-data :show="!ticketHistory && !ticketHistoryLoading"/>
    <div v-if="ticketHistoryLoading">
      <loader :show="true"/>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ModalService from "@/modules/modals/services/modal.service";
import ModalTicket from "@/components/ModalTicket.vue";
import NoData from "@/components/NoData.vue";
import Loader from "@/components/Loader.vue";
import Vue from "vue";

export default {
  name: 'TicketHistory',
  components: {Loader, NoData},
  computed: {
    Vue() {
      return Vue
    },
    ...mapGetters([
      'selectedDevice',
      'ticketHistory',
      'ticketHistoryLoading',
    ])
  },
  methods: {
    ...mapActions([
      'downloadDeviceTicketHistory'
    ]),
    getTicket(ticketId) {
      ModalService.open(ModalTicket, {assetId: this.selectedDevice.Id, ticketId: ticketId})
    },
  },
  mounted() {
    this.downloadDeviceTicketHistory(this.selectedDevice.Id)
  }
}
</script>

<style lang="sass" scoped>
.case-number
  text-align: left

table
  width: 100%

th
  text-transform: uppercase

td, th
  padding: 5px
  text-align: center

tr:nth-child(even)
  @apply bg-gray-100
</style>
